import * as apple from 'js/apple'
import { authenticateWithService } from './authenticateWithService'

export const loginWithApple = () => {
  return apple.login().then(({ apple_uid }) => {
    return authenticateWithService('apple', { apple_uid })
  })
}
